import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import exam from './exam';
import service from './service';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    error: null,
    errorCount: 0,
    sidebarOpened: false,
    offCanvasNavOpened: false
  },
  getters: {
    error: e => e.error,
    sidebarOpened: e => e.sidebarOpened,
    offCanvasNavState: e => e.offCanvasNavOpened
  },
  mutations: {
    setSidebarState(state, opened) {
      state.sidebarOpened = opened;
    },
    setOffCanvasNavState(state, opened) {
      state.offCanvasNavOpened = opened;
    },
    setError(state, err) {
      state.error = err + ' #' + state.errorCount++;
    },
    clearError(state) {
      state.error = null;
    }
  },
  actions: {},
  modules: {
    auth,
    exam,
    service
  }
});
